import styled from 'styled-components';

import React from 'react';

const RadioButtonWrap = styled.div`
  display: flex;
  align-items: center;
  label {
    display: flex;
    :hover {
      cursor: pointer;
    }
  }
  input {
    padding-right: ${({ theme }) => theme.spacing01};
    opacity: 0;
  }
  .radio-label-text {
    color: ${({ theme }) => theme.colorText70};
    text-transform: capitalize;
    display: flex;
    align-items: center;
  }
`;

const RadioWrap = styled.div`
  height: 20px;
  width: 20px;
  flex-shrink: 0;
  border: ${(props) => (props.checked ? '0px' : '1px')} solid ${({ theme }) => theme.colorText70};
  border-radius: 50%;
  margin-right: ${({ theme }) => theme.spacing01};
  position: relative;
  background: ${(props) => (props.checked ? props.theme.colorPrimary70 : 'transparent')};
  .radio-dot-checked {
    height: 10px;
    width: 10px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    border-radius: 50%;
    flex-shrink: 0;
    background: ${(props) => (props.checked ? 'white' : 'transparent')};
  }
`;

export default function RadioButton({ label, value, checked, onChange }) {
  return (
    <RadioButtonWrap>
      <label name={label} htmlFor={value}>
        <RadioWrap checked={checked}>
          <div className="radio-dot-checked"></div>
          <input id={value} onChange={onChange} value={value} checked={checked} type="radio" />
        </RadioWrap>
        <div className="radio-label-text">{label}</div>
      </label>
    </RadioButtonWrap>
  );
}
